var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isRouterAlive)?_c('router-view',{key:_vm.$route.fullPath}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }